<template>
  <div>
    <h4>Brand - Overview</h4>
    <div>
      <button @click="modaltest">
        test
      </button>

      <font-awesome-icon
        :icon="['fas', 'books']"
        size="6x"
        class="text-primary"
      />
      <font-awesome-icon
        :icon="['fal', 'books']"
        size="6x"
        rotation="180"
      />
      <font-awesome-icon
        :icon="['fad', 'books']"
        size="6x"
        :style="{'--fa-primary-color': '#F9278E', '--fa-secondary-color': '#82868B'}"
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    modaltest() {
      console.log('something here happen')
    },
  },
}
</script>
